export const ACTUALIZAR_LIST_CATEGORIASRRHH = "ACTUALIZAR_LIST_CATEGORIASRRHH";
export const MODIFICAR_CATEGORIASRRHH = "MODIFICAR_CATEGORIASRRHH";
export const AGREGAR_CATEGORIASRRHH = "AGREGAR_CATEGORIASRRHH";  
export const ELIMINAR_CATEGORIASRRHH = "ELIMINAR_CATEGORIASRRHH";